var _classCallCheck = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var Promise = require('bluebird'),
    _require = require('./util'),
    toHex = _require.toHex;

function waitOnCommitAck(factomd, txid, timeout) {
  return waitOnAck(factomd, txid, 'c', 'commitdata', timeout, 'entry-commit');
}

function waitOnRevealAck(factomd, hash, chainId, timeout) {
  return waitOnAck(factomd, hash, toHex(chainId), 'entrydata', timeout, 'entry-reveal');
}

function waitOnFactoidTransactionAck(factomd, txId, timeout) {
  return waitOnAck(factomd, txId, 'f', null, timeout, 'factoid-transaction');
}

function waitOnAck(factomd, hash, chainId, ackResponseField, to, ackType) {
  if (!hash || !chainId) {
    return Promise.reject(new AckError('Invalid argument: hash or chain ID is missing', ackType, hash));
  }

  var timeout = to || 60;
  var startTime = Date.now();
  return new Promise(function (resolve, reject) {
    var clearId = setInterval(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var error, ackResponse, status;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return factomd.call('ack', {
                hash: hash,
                chainid: chainId
              }).catch(function (e) {
                clearInterval(clearId);
                error = e;
              });

            case 3:
              ackResponse = _context.sent;

              if (!error) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", reject(new AckError(error, ackType, hash)));

            case 6:
              status = ackResponseField ? ackResponse[ackResponseField].status : ackResponse.status;

              if (!(status !== 'Unknown' && status !== 'NotConfirmed')) {
                _context.next = 10;
                break;
              }

              clearInterval(clearId);
              return _context.abrupt("return", resolve(status));

            case 10:
              if (!(Date.now() - startTime > timeout * 1000)) {
                _context.next = 13;
                break;
              }

              clearInterval(clearId);
              return _context.abrupt("return", reject(new AckError('Timeout', ackType, hash)));

            case 13:
              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              clearInterval(clearId);
              return _context.abrupt("return", reject(new AckError('Unexpected error: ' + _context.t0.message, ackType, hash)));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 15]]);
    })), 500);
  });
}

var AckError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(AckError, _Error);

  function AckError(error, ackType, hash) {
    var _this;

    _classCallCheck(this, AckError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AckError).call(this, "Acknowledgement of type [".concat(ackType, "] failed for [").concat(hash, "]: ").concat(error)));
    _this.ackType = ackType;
    _this.hash = hash;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), AckError);
    }

    return _this;
  }

  return AckError;
}(_wrapNativeSuper(Error));

module.exports = {
  waitOnCommitAck: waitOnCommitAck,
  waitOnRevealAck: waitOnRevealAck,
  waitOnFactoidTransactionAck: waitOnFactoidTransactionAck
};